import { request } from '@kibt/krn-utils';
import { $k18n } from './i18n';
import { radar } from './log';
import { Toast } from '@kibt/meta-ui-krn';
import { setPrestoreDataFromRes } from './prestoreDetail';
import { getUrlPathname } from './url';

/**
 * 全局异常拦截器
 * 注意：KRN场景下和一码多投H5场景下参数不一样
 * 1.KRN场景下：可以获得response: any, originResponse: any, request: any, originRequest: any, extraConfig?: any 五个参数
 * 2.H5场景下：亚杰最初封装的时候返回了reponse.data，不是AxiosResponse对象，因进而获取不到AxiosRequestConfig，  由于现在已经被各业务大量使用不好改了，后面如果有需求再看怎么统一结构吧
 */

/**
 * 全局异常拦截器有问题，如果出现异常，出触发两次，后面@chengyajie 修复，目前先通过业务代码来节流处理
 */
const throttleToastObj = {
    api: '',
    timeStamp: 0,
};

const toastMsg = (request, message) => {
    let showToast = false;
    if (request?.url && throttleToastObj.api !== request?.url) {
        throttleToastObj.api = request.url;
        throttleToastObj.timeStamp = Date.now().valueOf();
        showToast = true;
    } else {
        const now = Date.now().valueOf();
        if (now - throttleToastObj.timeStamp > 1000) {
            showToast = true;
            throttleToastObj.timeStamp = now;
        }
    }
    showToast && Toast.show(message);
};
request?.interceptors?.response.use(((response: any, originResponse?: any, request?: any, originRequest?: any, extraConfig?: any) => {
    const { toastError: krnApiToastError } = extraConfig || {};
    const { toastError: h5ApiToastError } = request?.extra || {};
    // 增加商详页预存的相关处理
    setTimeout(() => {
        try {
            setPrestoreDataFromRes({
                res: response,
                api: getUrlPathname(request?.url || ''),
            });
        } catch (e) {}
    }, 2000);
    const message = $k18n('系统繁忙，请稍后再试');
    if (response instanceof Error) {
        console.log('KRN_Ecomm_Defalut_Network_ErrorMessage', request, response);
        radar.event({
            name: 'KRN_Ecomm_Defalut_Network_ErrorMessage',
            params: {
                extData: {
                    request,
                    response,
                },
            },
        });
        if (krnApiToastError ?? h5ApiToastError ?? true) {
            toastMsg(request, message);
        }
        return Promise.reject(response);
    }

    if (response?.result !== 1) {
        if (krnApiToastError ?? h5ApiToastError ?? true) {
            toastMsg(request, response?.message || message);
        }
        return Promise.reject(response);
    }
    return response;
}) as any);
